import { render, staticRenderFns } from "./MultipleUploadReports.vue?vue&type=template&id=5bd52f34&"
import script from "./MultipleUploadReports.vue?vue&type=script&lang=js&"
export * from "./MultipleUploadReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports